import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26143da6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter" }

import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import { customerProductMskuEdit } from '@/apis/inShipping'
import { ElMessage } from 'element-plus'
import SvgIcon from '@/components/icons/SvgIcon.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['row'],
  setup(__props) {

const props = __props


const saveCustomerProductMsku = (row: any) => {
  const { shopProductSkuId } = row
  const value = customerProductMsku.value.trim()
  editing.value = false
  if (value !== props.row?.customerProductMsku) {
    customerProductMskuEdit({ customerProductMsku: value, shopProductSkuId }).then((res:any) => {
      if (!res.success) return
      ElMessage.success(t('保存成功'))
      row.customerProductMsku = value
    })
  } else {
    customerProductMsku.value = row.customerProductMsku ?? ''
  }
}

const editing = ref(false)
const input = ref()
const show = () => {
  editing.value = true
  input.value.focus()
}

const customerProductMsku = ref(props.row?.customerProductMsku ?? '')

watch(() => props.row?.customerProductMsku, (v) => {
  customerProductMsku.value = v
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tooltip, {
      placement: "top",
      effect: "light",
      disabled: !customerProductMsku.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(customerProductMsku.value), 1)
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("a", {
          class: "show-one-line",
          onClick: show
        }, [
          _createTextVNode(_toDisplayString(customerProductMsku.value) + " ", 1),
          _createVNode(SvgIcon, {
            name: "pencil",
            style: {"color":"var(--acolor)"}
          })
        ], 512), [
          [_vShow, !editing.value]
        ])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        ref: (_value, _refs) => {
          _refs['input'] = _value
          input.value = _value
        },
        modelValue: customerProductMsku.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerProductMsku).value = $event)),
        size: "small",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (saveCustomerProductMsku(__props.row))),
        maxlength: "100"
      }, null, 8, ["modelValue"])
    ], 512), [
      [_vShow, editing.value]
    ])
  ], 64))
}
}

})